import fetch from "@/utils/fetch";
// import { stringify } from "qs";

const API_BASE = window.SERVERAPI.API_BASE;

// 跟进项目列表
export function GetProjectManagementPageList(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/M_ProjectManagement/GetProjectManagementPageList",
    method: "get",
    params
  });
}

// 根据项目ID获取详情
export function Get(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/M_ProjectManagementTotal/Get",
    method: "get",
    params
  });
}

// 根据客户名称模糊搜索
export function Search(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/M_CustomerManagement/Search",
    method: "get",
    params
  });
}

// 获取所有字典以及当前登录用户
export function getCommon() {
  return fetch({
    baseURL: API_BASE,
    url: '/Common/GetData',
    method: 'get'
  })
}

// 根据类型获取字典https://testmisapi.hzfanews.com/Dictionary/GetListByType?dictionaryType=MarketType
export function GetListByType(params) {
  return fetch({
    baseURL: API_BASE,
    url: '/Dictionary/GetListByType',
    method: 'get',
    params
  })
}

// 客户---新增
export function CustomerAdd(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/M_CustomerManagement/Add",
    method: "post",
    data
  });
}

// 客户---修改
export function CustomerUpdate(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/M_CustomerManagement/Update",
    method: "post",
    data
  });
}
// 项目---新增
export function ProjectAdd(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/M_ProjectManagement/Add",
    method: "post",
    data
  });
}
// 项目---修改
export function ProjectUpdate(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/M_ProjectManagement/Update",
    method: "post",
    data
  });
}
